module.exports = __webpack_public_path__ + "assets/img/83420a668134f7fc008d1bfc39776a48.svg";